import React, { Children } from "react";
import styles from "./HomePage.module.css";
import { Carousel, Image, Spin, Alert } from "antd";
import { HeaderClass, Footer } from "../../components";
import { useNavigate } from "react-router-dom";
import { apiGet, apiPost } from "../../utils/axiosFn";
import { CaretRightOutlined, ScheduleTwoTone } from "@ant-design/icons";
import "./HomePage.css";

const withHomePage = (Children: any) => {
  return (props: any) => {
    const navigate = useNavigate();
    return <Children {...props} navigate={navigate} />;
  };
};

class HomePageComponent extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      obj: null,
      isLoading: true,
      banner: [],
      smallBanner: [],
      navList: [],
    };
  }

  async componentDidMount() {
    try {
      const res = await apiGet("/api/common/articleTypeList", null, null, null);
      this.setState({ navList: res });
    } catch (error) {
      alert(error);
    }
    try {
      const res = await apiGet("/api/common/index", null, null, null);
      this.setState({ obj: res });
      this.setState({ isLoading: false });
    } catch (error) {
      // alert(error)
      this.setState({ isLoading: false });
    }

    try {
      const data = {
        page: 1,
        size: 5,
        type: "首页大图",
      };
      const res = await apiGet(
        "/api/banner/page",
        { params: data },
        null,
        null
      );
      this.setState({ banner: res });
    } catch (error) {
      alert(error);
    }

    try {
      const data = {
        page: 1,
        size: 5,
        type: "首页下面图",
      };
      const res = await apiGet(
        "/api/banner/page",
        { params: data },
        null,
        null
      );
      this.setState({ smallBanner: res });
    } catch (error) {
      alert(error);
    }
  }

  goToItem(val: any) {
    const { navigate } = this.props;
    return () => {
      navigate(`/item/${val}`, {
        state: {
          id: val,
          text: val,
        },
      });
      const obj = this.state.navList.find((x: any) => x.label === val);
      window.sessionStorage.setItem("active", obj.value);
    };
  }

  goToDetails(id: any) {
    const { navigate } = this.props;
    return () => {
      navigate(`/details/${id}`, {
        state: { id: id, text: "" },
      });
    };
  }

  render() {
    const { navigate } = this.props;
    const { obj, isLoading, banner, smallBanner, navList } = this.state;

    if (isLoading)
      return (
        <Spin
          tip="Loading..."
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "500px",
          }}
        ></Spin>
      );
    if (!isLoading)
      return (
        <>
          <HeaderClass />
          <div className={styles["qaz"]}>
            <Carousel autoplay className={styles["cccc"]}>
              {banner.map((item: any, index: number) => {
                return (
                  <Image
                    key={index}
                    className={styles["cccc"]}
                    src={item.img}
                    onClick={this.goToDetails(item.id)}
                  />
                );
              })}
            </Carousel>
          </div>
          <div className={styles["w"]}>
            <div className={styles["afa_item"]}>
              <div className={styles["gag_title"]}>
                <div>
                  <img src="" alt="" />
                  <ScheduleTwoTone
                    style={{ fontSize: "20px", marginRight: "7px" }}
                  />
                  {obj.list11 ? obj.list11[0].articleTypeName : ""}
                </div>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={this.goToItem(
                    obj.list11 ? obj.list11[0].articleTypeName : ""
                  )}
                >
                  更多
                  <CaretRightOutlined twoToneColor="#eb2f96" />
                </div>
              </div>
              <div className={styles["r123_content"]}>
                <div className={styles["fw_left"]}>
                  <div className={styles["tsd_line"]}></div>
                  <div className={styles["fds1_crcle"]}></div>
                  <div className={styles["tsd_line"]}></div>
                  <div className={styles["fds1_crcle"]}></div>
                  <div className={styles["tsd_line"]}></div>
                  <div className={styles["fds1_crcle"]}></div>
                  <div className={styles["tsd_line"]}></div>
                  <div className={styles["fds1_crcle"]}></div>
                  <div className={styles["tsd_line"]}></div>
                  <div className={styles["fds1_crcle"]}></div>
                  <div className={styles["tsd_line"]}></div>
                </div>
                <div className={styles["f_right"]}>
                  {obj.list11?.map((item: any) => {
                    return (
                      <div
                        key={item.id}
                        style={{ cursor: "pointer", height: "62px" }}
                        onClick={this.goToDetails(
                          obj.list11.length > 0 ? obj.list11[0].id : ""
                        )}
                        className={styles["gsd23_item"]}
                      >
                        {item.title}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className={styles["afa_item"]}>
              <div className={styles["gag_title"]}>
                <div
                  style={{
                    background: "#015A9A",
                    color: "#fff",
                    padding: "3px 20px",
                    borderTopLeftRadius: "10px",
                    borderTopRightRadius: "10px",
                  }}
                >
                  {obj.list12 ? obj.list12[0].articleTypeName : ""}
                </div>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={this.goToItem(
                    obj.list12 ? obj.list12[0].articleTypeName : ""
                  )}
                >
                  更多
                  <CaretRightOutlined twoToneColor="#eb2f96" />
                </div>
              </div>
              <div
                style={{ marginTop: "0", flexDirection: "column" }}
                className={styles["r123_content"]}
                onClick={this.goToDetails(
                  obj.list12.length > 0 ? obj.list12[0].id : ""
                )}
              >
                <Image
                  className={styles["hgu2_img"]}
                  src={obj.list12 ? obj.list12[0].img : ""}
                  fallback="data:image/png;base64,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"
                />
                <div
                  style={{ cursor: "pointer" }}
                  className={styles["utd2_text"]}
                >
                  {obj.list12 ? obj.list12[0].shortContent : ""}
                </div>
              </div>
            </div>
            <div
              style={{ height: "392px", overflow: "hidden" }}
              className={styles["afa_item"]}
            >
              <div className={styles["gag_title"]}>
                <div
                  style={{
                    background: "#015A9A",
                    color: "#fff",
                    padding: "3px 20px",
                    borderTopLeftRadius: "10px",
                    borderTopRightRadius: "10px",
                  }}
                >
                  {obj.list21.length > 0 ? obj.list21[0].articleTypeName : ""}
                </div>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={this.goToItem(
                    obj.list21.length > 0 ? obj.list21[0].articleTypeName : ""
                  )}
                >
                  更多
                  <CaretRightOutlined twoToneColor="#eb2f96" />
                </div>
              </div>
              <div
                style={{ flexDirection: "column", height: "355px" }}
                className={styles["r123_content"]}
              >
                <div
                  className={styles["goj2_item"]}
                  onClick={this.goToDetails(
                    obj.list21.length > 0 ? obj.list21[0].id : ""
                  )}
                >
                  <img
                    src={obj.list21.length > 0 ? obj.list21[0].img : ""}
                    alt=""
                  />
                  <div className={styles["uhb4_text"]}>
                    <div>
                      {obj.list21.length > 0 ? obj.list21[0].title : ""}
                    </div>
                    <div>{obj.list21 ? obj.list21[0].shortContent : ""}</div>
                  </div>
                </div>
                {obj.list21.slice(1, 5).map((item: any) => {
                  return (
                    <div
                      onClick={this.goToDetails(item.id)}
                      key={item.id}
                      className={styles["og9_item"]}
                    >
                      <div> &nbsp; {item.title}</div>
                      <div>{item.createTime}</div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div
              style={{ height: "392px", overflow: "hidden" }}
              className={styles["afa_item"]}
            >
              <div className={styles["gag_title"]}>
                <div
                  style={{
                    background: "#015A9A",
                    color: "#fff",
                    padding: "3px 20px",
                    borderTopLeftRadius: "10px",
                    borderTopRightRadius: "10px",
                  }}
                >
                  {obj.list22.length > 0 ? obj.list22[0].articleTypeName : ""}
                </div>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={this.goToItem(
                    obj.list22.length > 0 ? obj.list22[0].articleTypeName : ""
                  )}
                >
                  更多
                  <CaretRightOutlined twoToneColor="#eb2f96" />
                </div>
              </div>
              <div
                style={{ flexDirection: "column", height: "355px" }}
                className={styles["r123_content"]}
              >
                <div
                  className={styles["goj2_item"]}
                  onClick={this.goToDetails(
                    obj.list22.length > 0 ? obj.list22[0].id : ""
                  )}
                >
                  <img
                    src={obj.list22.length > 0 ? obj.list22[0].img : ""}
                    alt=""
                  />
                  <div className={styles["uhb4_text"]}>
                    <div>
                      {obj.list22.length > 0 ? obj.list22[0].title : ""}
                    </div>
                    <div>{obj.list22 ? obj.list22[0].shortContent : ""}</div>
                  </div>
                </div>
                {obj.list22.slice(1, 5).map((item: any) => {
                  return (
                    <div
                      onClick={this.goToDetails(item.id)}
                      key={item.id}
                      className={styles["og9_item"]}
                    >
                      <div> &nbsp; {item.title}</div>
                      <div>{item.createTime}</div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div
              style={{ height: "392px", overflow: "hidden" }}
              className={styles["afa_item"]}
            >
              <div className={styles["gag_title"]}>
                <div
                  style={{
                    background: "#015A9A",
                    color: "#fff",
                    padding: "3px 20px",
                    borderTopLeftRadius: "10px",
                    borderTopRightRadius: "10px",
                  }}
                >
                  {obj.list31.length > 0 ? obj.list31[0].articleTypeName : ""}
                </div>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={this.goToItem(
                    obj.list31.length > 0 ? obj.list31[0].articleTypeName : ""
                  )}
                >
                  更多
                  <CaretRightOutlined twoToneColor="#eb2f96" />
                </div>
              </div>
              <div
                style={{ flexDirection: "column", height: "355px" }}
                className={styles["r123_content"]}
              >
                <div
                  className={styles["goj2_item"]}
                  onClick={this.goToDetails(
                    obj.list31.length > 0 ? obj.list31[0].id : ""
                  )}
                >
                  <img
                    src={obj.list31.length > 0 ? obj.list31[0].img : ""}
                    alt=""
                  />
                  <div className={styles["uhb4_text"]}>
                    <div>
                      {obj.list31.length > 0 ? obj.list31[0].title : ""}
                    </div>
                    <div>{obj.list31 ? obj.list31[0].shortContent : ""}</div>
                  </div>
                </div>
                {obj.list31.slice(1, 5).map((item: any) => {
                  return (
                    <div
                      onClick={this.goToDetails(item.id)}
                      key={item.id}
                      className={styles["og9_item"]}
                    >
                      <div> &nbsp; {item.title}</div>
                      <div>{item.createTime}</div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div
              style={{ height: "392px", overflow: "hidden" }}
              className={styles["afa_item"]}
            >
              <div className={styles["gag_title"]}>
                <div
                  style={{
                    background: "#015A9A",
                    color: "#fff",
                    padding: "3px 20px",
                    borderTopLeftRadius: "10px",
                    borderTopRightRadius: "10px",
                  }}
                >
                  {obj.list32.length > 0 ? obj.list32[0].articleTypeName : ""}
                </div>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={this.goToItem(
                    obj.list32.length > 0 ? obj.list32[0].articleTypeName : ""
                  )}
                >
                  更多
                  <CaretRightOutlined twoToneColor="#eb2f96" />
                </div>
              </div>
              <div
                style={{ flexDirection: "column", height: "355px" }}
                className={styles["r123_content"]}
              >
                <div
                  className={styles["goj2_item"]}
                  onClick={this.goToDetails(
                    obj.list32.length > 0 ? obj.list32[0].id : ""
                  )}
                >
                  <img
                    src={obj.list32.length > 0 ? obj.list32[0].img : ""}
                    alt=""
                  />
                  <div className={styles["uhb4_text"]}>
                    <div>
                      {obj.list32.length > 0 ? obj.list32[0].title : ""}
                    </div>
                    <div>{obj.list32 ? obj.list32[0].shortContent : ""}</div>
                  </div>
                </div>
                {obj.list32.slice(1, 5).map((item: any) => {
                  return (
                    <div
                      onClick={this.goToDetails(item.id)}
                      key={item.id}
                      className={styles["og9_item"]}
                    >
                      <div> &nbsp; {item.title}</div>
                      <div>{item.createTime}</div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div style={{ width: "1080px" }} className={styles["afa_item"]}>
              <div className={styles["gag_title"]}>
                <div
                  style={{
                    background: "#015A9A",
                    color: "#fff",
                    padding: "3px 20px",
                    borderTopLeftRadius: "10px",
                    borderTopRightRadius: "10px",
                  }}
                >
                  {obj.list41.length > 0 ? obj.list41[0].articleTypeName : ""}
                </div>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={this.goToItem(
                    obj.list41 ? obj.list41[0].articleTypeName : ""
                  )}
                >
                  更多
                  <CaretRightOutlined twoToneColor="#eb2f96" />
                </div>
              </div>
              <div
                style={{ width: "1080px", paddingBottom: "0" }}
                className={styles["r123_content"]}
              >
                {obj.list41.map((item: any) => {
                  return (
                    <img
                      width={130}
                      height={50}
                      className="jigi_123j"
                      onClick={this.goToDetails(item.id)}
                      key={item.id}
                      src={obj.list41.length > 0 ? item.img : ""}
                    />
                  );
                })}
              </div>
            </div>

            <div style={{ width: "1080px" }} className={styles["afa_item"]}>
              <div className={styles["gag_title"]}>
                <div
                  style={{
                    background: "#015A9A",
                    color: "#fff",
                    padding: "3px 20px",
                    borderTopLeftRadius: "10px",
                    borderTopRightRadius: "10px",
                  }}
                >
                  友情链接
                </div>
                <div>
                  更多
                  <CaretRightOutlined twoToneColor="#eb2f96" />
                </div>
              </div>
              <div
                style={{ width: "1080px", padding: "20px 0" }}
                className={styles["r123_content"]}
              >
                {obj.linkList.map((item: any) => {
                  return (
                    <div
                      style={{
                        padding: "0 10px",
                        borderRight: "1px solid #000",
                        lineHeight: "15px",
                        cursor: "pointer",
                      }}
                      onClick={() => window.open(item.url)}
                      key={item.url}
                    >
                      {item.name}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <Footer />
        </>
      );
  }
}

export const HomePage = withHomePage(HomePageComponent);
